// Código da EAP para leitura humana.
//
// O código salvo é a concatenação do código da construtora, do código da obra e dos
// níveis da EAP: `LUMIS` + `248` + `001` `01` `001` `001` `005`. A raiz (construtora +
// obra) é o `wbs_code_id` do projeto, e cada nível tem largura fixa (ver
// `LEVEL_OFFSETS` em disbursement/hierarchy.js): unidade 3, célula 2, etapa 3,
// subetapa 3 e serviço 3. Nos relatórios a raiz sai e os níveis ganham pontos, no
// mesmo formato da tela ("EAP #001.01…"): `001.01.001.001.005`.

const LEVEL_WIDTHS = [3, 2, 3, 3, 3];

// A raiz mais longa que prefixa o código: com mais de um centro de custo, uma raiz
// pode ser prefixo de outra.
const matchingRoot = (code, roots) => roots
  .map((root) => String(root ?? ""))
  .filter((root) => root && code.startsWith(root))
  .sort((a, b) => b.length - a.length)[0];

export const wbsRootOf = (wbsCodeId, roots = []) => matchingRoot(String(wbsCodeId ?? ""), roots);

export const projectWbsRoots = (project) => {
  const ids = Array.isArray(project?.wbs_code_ids) ? project.wbs_code_ids : [];
  return [...ids, project?.wbs_code_id].filter(Boolean).map(String);
};

// Sem raiz conhecida o código sai como veio: cortar por tamanho fixo arriscaria
// comer um pedaço da EAP, porque o código da construtora não tem largura fixa.
export const formatWbsCode = (wbsCodeId, roots = []) => {
  const code = String(wbsCodeId ?? "");
  const root = matchingRoot(code, roots);
  if (root === undefined) return code;
  let rest = code.slice(root.length);
  const parts = [];
  for (const width of LEVEL_WIDTHS) {
    if (!rest) break;
    parts.push(rest.slice(0, width));
    rest = rest.slice(width);
  }
  if (rest) parts.push(rest);
  return parts.join(".");
};

// Profundidade do nó abaixo da obra: 0 para a obra, 1 para unidade, …, 5 para serviço.
export const wbsDepth = (wbsCodeId, roots = []) => {
  const formatted = formatWbsCode(wbsCodeId, roots);
  const code = String(wbsCodeId ?? "");
  if (formatted === code && matchingRoot(code, roots) === undefined) return null;
  return formatted ? formatted.split(".").length : 0;
};
